
export const formatMatches = (format) => {
    if (format === null) {
        throw new Error("Match format cannot be null!")
    }
    return [format?.numberOfPeriods, format?.periodDuration ];
}